import { useContext } from 'react'
import { HistoryContext } from '@/contexts/HistoryContext'

const useCustomHistory = () => useContext(HistoryContext)

export default useCustomHistory
